<template>
  <div class="form-elements">
    <div class="row">
      <div class="flex xs12">
        <va-card :title="$t('forms.inputs.compatibilities')">
          <form @submit.prevent>
            <div class="row">
              <div class="flex md4 sm6 xs12">
                <va-input
                  v-model="compatibilitiesParams.compatibility_sequence"
                  :label="$t('forms.inputs.compatibility_sequence')"
                />
              </div>
              <div class="flex md4 sm6 xs12">
                <va-select
                  :label="$t('forms.selects.productGroups')"
                  v-model="compatibilitiesParams.compatible_product_group"
                  keyBy="id"
                  textBy="name"
                  :options="listProductGroups"
                  searchable
                />
              </div>
            </div>
            <div class="row">
              <div class="flex xs12 sm4">
                <va-button
                  v-if="this.compatibilitiesParams.compatibilityId == ''"
                  medium
                  inline
                  color="secondary"
                  icon="fa fa-plus"
                  class="ma-0"
                  @click="create(compatibilitiesParams)"
                >
                  {{ $t('menu.add') }}
                </va-button>
                
                <va-button
                  v-if="this.compatibilitiesParams.compatibilityId != ''"
                  medium
                  inline
                  color="secondary"
                  icon="fa fa-plus"
                  class="ma-0"
                  @click="update(compatibilitiesParams)"
                >
                  {{ $t('menu.update') }}
                </va-button>

                <va-button
                  v-if="this.compatibilitiesParams.compatibilityId != ''"
                  medium
                  inline
                  color="gray"
                  icon="fa fa-refresh"
                  class="ma-1"
                  @click="clear()"
                >
                  {{ $t('menu.clear') }}
                </va-button>

              </div>

              <div class="flex xs12 sm3">
                <va-button
                  medium
                  inline
                  color="#ff842b"
                  icon="fa fa-chevron-left"
                  class="ma-0"
                  :to="{ name: 'product-groups', params: {
                    current_page: this.$route.params.current_page, 
                    searchName: this.$route.params.searchName, 
                    perPage: this.$route.params.perPage }
                    }"
                >
                  {{ $t('menu.back') }}
                </va-button>
              </div>
            </div>

            <div v-show="loading" class="text--center pb-4">
              <div class="flex-center spinner-box" style="margin-top: 50px;">
                <slot name="loading">
                  <spring-spinner
                    slot="loading"
                    :animation-duration="currentDuration"
                    :is="spload.name"
                    :color="spinnersColor"
                    :size="config.size"
                  />
                </slot>
              </div>
            </div>

            <va-data-table
              :fields="fields"
              :data="listCompatibilities"
              no-pagination
              v-show="!loading"
            >
              <template slot="actions" slot-scope="props" >
                <va-button
                  small 
                  inline 
                  color="green" 
                  icon="fa fa-edit"
                  class="ma-0"
                  @click="editCompatibility(props.rowData.id)"
                >
                  {{ $t('tables.edit') }}
                </va-button>
                <va-button 
                  small 
                  inline 
                  color="danger" 
                  icon="fa fa-remove"
                  class="ma-1"
                  @click="showModalRemove = true, codeCompatibilityRemove = props.rowData.id"
                >
                  {{ $t('tables.delete') }}
                </va-button>
              </template>
            </va-data-table>
          </form>
        </va-card>
      </div>
    </div>
      <va-modal
        v-model="showModalRemove"
        size="small"
        :title="$t('modal.remove')"
        :message="$t('modal.messageRemoveCompatibility')"
        hideDefaultActions
        :color="this.$themes.secondary"
      >
      <va-button
        color="danger"
        class="ma-2"
        @click="showModalRemove = false">
        {{$t('modal.cancel')}}
      </va-button>

      <va-button
        color="secondary"
        class="ma-2"
        @click="remove(codeCompatibilityRemove), showModalRemove = false">
        {{$t('modal.confirm')}}
      </va-button>
    </va-modal>
  </div>
</template>

<script>

import CompatibilityAPI from '@/services/CompatibilityAPI'
import ProductGroupAPI from '@/services/ProductGroupAPI'
import * as spinners from 'epic-spinners'
import { showError } from '@/global'

export default {
  name: 'form-vehicle-bays',
  components: {
    ...spinners,
  },
  data () {
    return {
      compatibilitiesParams: {
        compatibilityId: '',
        compatibility_sequence: '',
        product_group_id: this.$route.params.id,
        compatible_product_group: ''
      },
      listProductGroups: [],
      listCompatibilities: [],
      loading: false,
      config: {
        size: 80,
        group: 4,
        duration: 1500,
      },
      spinnersColor: this.$themes.secondary,
      currentDuration: 1500,
      showModalRemove: false,
      codeCompatibilityRemove: ""
    }
  },
  async mounted () {
    ProductGroupAPI.getAllProductGroups().then(response => {
      this.listProductGroups = response.data.product_groups.filter(x => {
        return x.id != this.$route.params.id
      })
    })

    this.getAllCompatibilities();
    
  },
  computed: {
    fields () {
      return [
      {
        name: 'compatibility_sequence',
        title: this.$t('tables.compatibilities.compatibility_sequence'),
        width: '10%',
      },
      {
        name: 'compatible_product_group_name',
        title: this.$t('tables.compatibilities.compatible_product_group_name'),
        width: '20%',
      },
      {
        name: '__slot:actions',
        dataClass: 'text-right',
      }]
    },
    spload () {
      // return spinners.SpinnerName
      return spinners.ScalingSquaresSpinner
    }
  },

  methods: {
    getAllCompatibilities () {
      this.loading = true

      CompatibilityAPI.getAllCompatibilities(this.$route.params.id).then(response => {
        this.listCompatibilities = response.data.compatibilities
        this.loading = false
      })
    },

    create (compatibilitiesParams) {
      CompatibilityAPI.createCompatibility(compatibilitiesParams).then(response => {
        this.data = response.data;

        this.getAllCompatibilities()
        
        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })
      }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
    },

    remove (codeCompatibilityRemove) {
      CompatibilityAPI.deleteCompatibility(codeCompatibilityRemove).then(response => {
        this.data = response.data;

        this.getAllCompatibilities()
        
        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
      })
    },

    editCompatibility(compatibilityId) {
      CompatibilityAPI.getCompatibilityById(compatibilityId).then(response => {
        let compatibility = response.data.compatibility
        this.compatibilitiesParams.product_group_id = compatibility.product_group_id
        this.compatibilitiesParams.compatibility_sequence = compatibility.compatibility_sequence
        this.compatibilitiesParams.compatibilityId = compatibility.id
      })
    },

    async update(compatibilitiesParams) {
      await CompatibilityAPI.updateCompatibility(compatibilitiesParams).then(response => {
        this.data = response.data
        this.saveSequence(this.compatibilitiesParams.compatibility_sequence, this.compatibilitiesParams.compatibilityId)
        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })
      }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
    },
    async saveSequence(compatibility_sequence, compatibilityId) {
    CompatibilityAPI.saveSequence(compatibility_sequence, compatibilityId).then(response => {
      this.getAllCompatibilities()
      this.showToast(response.data.message, {
        icon: 'fa-thumbs-o-up',
        position: 'top-right',
        })
      }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
    },
    clear() {
      this.compatibilitiesParams.compatibility_sequence = ''
      this.compatibilitiesParams.compatibilityId = ''
      this.compatibilitiesParams.compatible_product_group = ''
    },
  }
}
</script>

<style>
  .row.row-inside {
    max-width: none;
  }
</style>
